import React from 'react';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import { ChevronRightIcon } from '@heroicons/react/24/solid';

interface BreadcrumbItem {
  label: string;
  link: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '' }) => {
  return (
    <nav aria-label='Breadcrumb' className={`mb-6 ${className}`}>
      <ol className='flex items-center flex-wrap p-3 bg-white shadow-sm rounded-lg border border-gray-100'>
        {items.map((item, index) => (
          <li key={index} className='flex items-center'>
            {index > 0 && (
              <ChevronRightIcon className='h-4 w-4 text-gray-400 mx-2' />
            )}
            {index === 0 && item.link ? (
              <Link
                to={item.link}
                className='flex items-center text-gray-600 hover:text-primary transition-colors'
              >
                <HomeOutlined className='mr-1' />
                <span className='text-sm'>{item.label}</span>
              </Link>
            ) : item.link ? (
              <Link
                to={item.link}
                className='text-sm text-gray-600 hover:text-primary transition-colors'
              >
                {item.label}
              </Link>
            ) : (
              <span className='text-sm font-medium text-primary'>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
